import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ReporteParesDto } from 'src/app/dto/reporte-pares-dto';
import { Periodo } from 'src/app/model/periodo';
import { PeriodoService } from 'src/app/services/periodo.service';
import { ReporteParesService } from 'src/app/services/reporte-pares.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reporte-dialog',
  templateUrl: './reporte-dialog.component.html',
  styleUrls: ['./reporte-dialog.component.css']
})
export class ReporteDialogComponent implements OnInit {

  reporte: ReporteParesDto[];
  form: FormGroup;
  periodos: Periodo[];
  NombrePeriodo: Periodo[];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ReporteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private ReporteService: ReporteParesService,
    private PeriodoService: PeriodoService
  ) { }

  ngOnInit() {
    this.adjustDialogSize();
    this.InitForm();
    this.obtenerPeriodos();
  }

  private adjustDialogSize() {
    const width = window.innerWidth;
    if (width < 576) {
      this.dialogRef.updateSize('95vw', 'auto');
    } else if (width < 768) {
      this.dialogRef.updateSize('85%', 'auto');
    } else {
      this.dialogRef.updateSize('550px', 'auto');
    }
  }

  InitForm() {
    this.form = this.fb.group({
      periodo: new FormControl('', Validators.required)
    })
  }

  obtenerPeriodos() {
    this.PeriodoService.obtenerperiodos().subscribe(data => {
      this.periodos = data;
    })
  }

  obtenerPares() {
    let periodo = Number(this.form.value.periodo);
    if (this.data.tipo === 'observaciones') {
      this.ReporteService.obtenerReporteObservaciones(periodo, this.data.uaa).subscribe(data => {
        if (data != null && data.length > 0) {
          this.ReporteService.exportObservacionesToExcel(data, this.data.uaaNombre);
        } else {
          this.errorNoData();
        }
      });
    } else {
      this.ReporteService.obtenerReportePares(periodo, this.data.uaa).subscribe(data => {
        this.reporte = data;
        if (this.reporte != null && this.reporte.length > 0) {
          this.ReporteService.exportToExcel(this.reporte, this.data.uaaNombre);
        } else {
          this.errorNoData();
        }
      });
    }
  }

  errorNoData() {
    Swal.fire({
      icon: "error",
      title: "ERROR",
      text: "No se encontró datos.",
      confirmButtonColor: "#8F141B"
    });
  }
}